exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vdatetime[data-v-da3acde6] {\n  padding: 8px 10px;\n  font-size: 16px;\n  border: solid 1px #ddd;\n  color: #444;\n}\n", ""]);

// exports
